import { Button } from "@mui/material"
import { CarModelSafetySystemDto } from "api"
import { MotionValue, useScroll, useTransform } from "framer-motion"
import dynamic from "next/dynamic"
import { useRef, useState } from "react"
import styled from "styled-components"
import { TypographyCenter } from "theme/shared"
import SafetyDoubleSwiper from "./SafetyDoubleSwiper"
import SafetyParallaxTwo from "./SafetyParallaxTwo"

const SafetyPopup = dynamic(() => import("./SafetyPopup"), { ssr: false })

const StyledSectionWrapper = styled.div`
  min-height: 100vh;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};
  justify-content: center;
`
const StyledMiniSectionWrapper = styled.div<{ $h?: string }>`
  height: ${(p) => (p.$h ? p.$h : "100vh")};
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};
  justify-content: center;
  margin-bottom: 80px;
  padding-top: 0px;
  justify-content: flex-start;
`

const StyledButton = styled(Button)`
  margin: 0px auto;
`
type SafetySectionProps = {
  data: CarModelSafetySystemDto
}
function useParallax(value: MotionValue<number>, distance: number) {
  return useTransform(value, [0, 1], [distance, -distance])
}
const SafetySection = ({ data }: SafetySectionProps) => {
  const [popUpOpen, setPopUpOpen] = useState(false)
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
  })
  const y = useParallax(scrollYProgress, 1000)

  return (
    <StyledSectionWrapper>
      <div ref={ref}>
        <SafetyParallaxTwo text={data?.mainTitle} y={y} />
        <SafetyDoubleSwiper data={data?.items} />
      </div>
      <StyledMiniSectionWrapper $h="200px">
        <TypographyCenter
          variant={"h2"}
          $mb="34px"
          $fontSize="20px"
          $fontWeight="300"
        >
          גלו עוד על אמצעי הבטיחות המוקפדים שלנו
        </TypographyCenter>
        <StyledButton variant="contained" onClick={() => setPopUpOpen(true)}>
          לכל אמצעי הבטיחות
        </StyledButton>
      </StyledMiniSectionWrapper>
      {popUpOpen && (
        <SafetyPopup
          data={data?.items}
          open={popUpOpen}
          onClose={() => setPopUpOpen(false)}
        />
      )}
    </StyledSectionWrapper>
  )
}

export default SafetySection
